import React from 'react';

import { CardId } from '@/console/features/card-layout/card-layout.types';
import { RecentDevicesCard } from '@/console/features/card-layout/components/recent-devices-card/recent-devices-card';
import { RecentGroupsCard } from '@/console/features/card-layout/components/recent-groups-card/recent-groups-card';
import { RecentPipelinesCard } from '@/console/features/card-layout/components/recent-pipelines-card/recent-pipelines-card';
import { RecentProjectsCard } from '@/console/features/card-layout/components/recent-projects-card/recent-projects-card';
import { Can } from '@/shared/features/permissions/components/can/can';

export const renderCards = (cardId: CardId): React.ReactNode => {
  switch (cardId) {
    case CardId.PROJECTS:
      return (
        <Can action="project:readProject">
          <RecentProjectsCard />
        </Can>
      );
    case CardId.DEVICES:
      return (
        <Can action="device:readDevice">
          <RecentDevicesCard />
        </Can>
      );
    case CardId.PIPELINES:
      return (
        <Can action="pipeline:readPipeline">
          <RecentPipelinesCard />
        </Can>
      );
    case CardId.GROUPS:
      return (
        <Can action="resourceGroup:readResourceGroup">
          <RecentGroupsCard />
        </Can>
      );
    default:
      return null;
  }
};
